import { IProduto } from "../../../Interfaces/Vendas/Produtos/ProdutosInterfaces";
import {
    ListarProdutosInteresseVendasService,
    ListarProdutosVendasService,
    ProdutoVendasService,
    TabelaPrecosProdutoVendasService,
} from "../../../Services/Vendas/Produtos/ProdutosService";
import { Controller } from "../../Controller";

export async function ListarProdutosInteresseVendasController(idCaso: number) {
    return Controller(ListarProdutosInteresseVendasService(idCaso));
}

export async function ListarProdutosVendasController() {
    return Controller(ListarProdutosVendasService());
}

export async function ProdutoVendasController(requestBody: IProduto) {
    return Controller(ProdutoVendasService(requestBody));
}

export async function TabelaPrecosProdutoVendasController(ID_PRODUTO: number) {
    return Controller(TabelaPrecosProdutoVendasService(ID_PRODUTO));
}
